import RoundTab from "components/RoundTabButtons/RoundTab";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "../../../customHooks/useWindowSize";

import LeftArrow_3 from "../../../assets/img/icons/LeftArrow_3.svg";
import RightArrow_3 from "../../../assets/img/icons/RightArrow_3.svg";
import AddSingleMemberDropdown from "../../../components/CustomDropdown/AddSingleMemberDropdown";
import FilterDropDownStyle from "../../../components/DropdownStyle/FilterDropDownStyle";
import Dropdown from "../../../components/ReactSelectDropdown";
import Select from "../../../components/ReactSelectDropdown";
import { filterOption } from "../../../components/ReactSelectDropdown/ReactSelectDropdown";
import ClearFilterButton from "../../../components/Search/clearFilterButton";
import DatePicker from "../../../components/SingleDatePicker/SingleDatePicker";
import { FilterButton } from "../../../styledComponents/buttons";
import {
  CommonFlex,
  CommonFlexWrap,
  FilterLabel,
  IconArrow,
  InputWithLabelSection,
  StatusDot,
} from "../../../styledComponents/common";
import { JobsInMapFilterContainer } from "../jobsInMapStyles";

const JobsInMapFilter = ({
  selectedOrganization,
  getOrganizationMembersList,
  organizationMembersList,
  selectedMember,
  selectMember,
  clearMember,
  selectedDate,
  singleDateChangeDaily,
  selectToday,
  getOfficesShortList,
  officesShortList,
  selectedOffice,
  selectOffice,
  activeTab,
  setActiveTab,
}) => {
  const { t } = useTranslation();
  const { width: viewWidth } = useWindowSize();
  const RESPONSIVE_BREAKPOINT = 1326;
  
  const orgType = selectedOrganization?.type || "operation";
  const isOperationType = orgType === "operation";
  const isResponsive = viewWidth < RESPONSIVE_BREAKPOINT;

  const activeTabOptions = [
    { value: "all", label: "All Jobs" },
    { value: "scheduled", label: "Scheduled" },
    { value: "in_progress", label: "In Progress" },
    { value: "completed", label: "Completed" },
    { value: "missed", label: "Missed" },
  ];

  const [officeOptions, setOfficeOptions] = useState([
    {
      label: `(${t("all_teams")})`,
      value: null,
    },
  ]);

  // Fetch offices and members on org change
  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      getOfficesShortList({ organization_id: selectedOrganization.id });
      getOrganizationMembersList({
        page: 1,
        organization_id: selectedOrganization.id,
        office_id: null,
      });
    }
  }, [selectedOrganization]);

  // Build office options
  useEffect(() => {
    if (officesShortList && officesShortList.length > 1) {
      let newArr = [
        {
          label: `(${t("all_teams")})`,
          value: null,
        },
      ];
      officesShortList.forEach(office => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList, t]);

  // Fetch members when office changes
  useEffect(() => {
    if (selectedOffice?.value && selectedOrganization?.id) {
      getOrganizationMembersList({
        page: 1,
        organization_id: selectedOrganization.id,
        office_id: selectedOffice.value,
      });
    } else if (selectedOrganization?.id) {
      getOrganizationMembersList({
        page: 1,
        organization_id: selectedOrganization.id,
        office_id: null,
      });
    }
  }, [selectedOffice, selectedOrganization]);

  const onMemberSelect = person => {
    selectMember(person);
  };

  const isToday = selectedDate && moment(selectedDate).isSame(moment(), "day");

  const isAdmin =
    localStorage.getItem("selected_organization_role") === "admin" ||
    localStorage.getItem("selected_organization_role") === "owner";

  return (
    <JobsInMapFilterContainer
      columns={
        isOperationType && isAdmin
          ? "max-content 57px minmax(300px, 1fr)"
          : "max-content 57px minmax(300px, 1fr)"
      }
      responsiveBreakpoint="1326px"
      style={{ width: "100%" }}
    >
      {/* Status */}
      <CommonFlexWrap
        disableResponsive
        gap="4px"
        style={{ alignSelf: "flex-end" }}
      >
        <RoundTab
          text="All Jobs"
          selected={activeTab === "all"}
          onClick={() => setActiveTab("all")}
          showIcon={false}
          // customIcon={<StatusDot status="scheduled" />}
          filled={activeTab === "all"}
        />
        <RoundTab
          text="Scheduled"
          selected={activeTab === "scheduled"}
          onClick={() => setActiveTab("scheduled")}
          customIcon={
            <StatusDot
              size="14px"
              status="scheduled"
              showBorder={activeTab === "scheduled"}
            />
          }
          gap={"4px"}
          filled={activeTab === "scheduled"}
        />
        <RoundTab
          text="In Progress"
          selected={activeTab === "in_progress"}
          onClick={() => setActiveTab("in_progress")}
          customIcon={
            <StatusDot
              size="14px"
              status="in_progress"
              showBorder={activeTab === "in_progress"}
            />
          }
          filled={activeTab === "in_progress"}
          gap={"4px"}
        />
        <RoundTab
          text="Completed"
          selected={activeTab === "completed"}
          onClick={() => setActiveTab("completed")}
          customIcon={
            <StatusDot
              size="14px"
              status="completed"
              showBorder={activeTab === "completed"}
            />
          }
          filled={activeTab === "completed"}
          gap={"4px"}
        />
        <RoundTab
          text="Missed"
          selected={activeTab === "missed"}
          onClick={() => setActiveTab("missed")}
          customIcon={
            <StatusDot
              size="14px"
              status="missed"
              showBorder={activeTab === "missed"}
            />
          }
          filled={activeTab === "missed"}
          gap={"4px"}
        />
      </CommonFlexWrap>

      {/* Member Filter (for admins/owners) */}
      {isAdmin && (
        <CommonFlexWrap>
          <InputWithLabelSection style={{ minWidth: "240px" }}>
            <FilterLabel>{t("assignee")}</FilterLabel>
            <AddSingleMemberDropdown
              updateState={person => onMemberSelect(person)}
              clearAssignee={clearMember}
              assigneeManage={selectedMember}
              membersList={organizationMembersList}
              page="jobs_in_map"
              closeDisabled={true}
            />
          </InputWithLabelSection>
        </CommonFlexWrap>
      )}

      {/* Date Picker */}
      <CommonFlexWrap
        style={{ width: "100%" }}
        justifyContent={isResponsive ? "flex-start" : "flex-end"}
        gap="4px"
      >
        <InputWithLabelSection>
          <FilterLabel>{t("date")}</FilterLabel>
          <CommonFlex gap="4px">
            <DatePicker
              id="jobsInMapFilterDate"
              date={selectedDate}
              onDateChange={date => singleDateChangeDaily(date)}
              placeholder="Select date..."
              allowPreviousDates
              width="200px"
            />
            <CommonFlex disableResponsive="true" gap="4px" margin="1.5px 0 0 0">
              <IconArrow
                onClick={() => singleDateChangeDaily("prev")}
                padding="5px"
                size="40px"
                src={LeftArrow_3}
              />
              <IconArrow
                margin="0 0 0 2px"
                onClick={() => singleDateChangeDaily("next")}
                padding="5px"
                size="40px"
                src={RightArrow_3}
              />
              <FilterButton
                type="gray"
                padding="10px"
                onClick={selectToday}
                margin="0 0 0 2px"
              >
                Today
              </FilterButton>
            </CommonFlex>
          </CommonFlex>
        </InputWithLabelSection>
      </CommonFlexWrap>

      {/* Team Filter (for admins/owners) */}
      {/* {isAdmin && isOperationType && (
        <InputWithLabelSection style={{ minWidth: "240px" }}>
          <FilterLabel>{t("team")}</FilterLabel>
          <Dropdown
            isSearchable
            isClearable={selectedOffice?.value}
            value={selectedOffice}
            options={officeOptions}
            placeholder="Select Team..."
            onChange={e => {
              e
                ? selectOffice(e)
                : selectOffice({
                    label: `(${t("all_teams")})`,
                    value: null,
                  });
            }}
            styles={FilterDropDownStyle({ height: "40px" })}
            filterOption={filterOption}
            components={{
              IndicatorSeparator: () => null,
              ClearIndicator: props => <ClearFilterButton {...props} />,
            }}
          />
        </InputWithLabelSection>
      )} */}
    </JobsInMapFilterContainer>
  );
};

export default JobsInMapFilter;
